var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransactionFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16986 7.50003C0.979863 7.50003 0.789863 7.43003 0.639863 7.28003C0.349863 6.99003 0.349863 6.51003 0.639863 6.22003L6.29986 0.560029C6.58986 0.270029 7.06986 0.270029 7.35986 0.560029C7.64986 0.850029 7.64986 1.33003 7.35986 1.62003L1.69986 7.28003C1.55986 7.43003 1.35986 7.50003 1.16986 7.50003Z",
    fill: "#FD2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82986 7.6575C6.63986 7.6575 6.44986 7.5875 6.29986 7.4375L0.639863 1.7775C0.349863 1.4875 0.349863 1.0075 0.639863 0.7175C0.929863 0.4275 1.40986 0.4275 1.69986 0.7175L7.35986 6.3775C7.64986 6.6675 7.64986 7.1475 7.35986 7.4375C7.20986 7.5875 7.01986 7.6575 6.82986 7.6575Z",
    fill: "#FD2B2B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFailed);
export default __webpack_public_path__ + "static/media/transactionFailed.8794f38ae9ecb60ca6a311b2b9ae92a8.svg";
export { ForwardRef as ReactComponent };